module.exports = __webpack_public_path__ + "img/mandeep-dhillon-fake-laugh.a598fefa.gif";